export function anchorScroll(lenis) {
    document.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

        const link = event.target.closest('a[href]');
        if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search || !url.hash) return;

        let id;
        try {
            id = decodeURIComponent(url.hash.slice(1));
        } catch {
            return;
        }

        const target = document.getElementById(id) || document.getElementsByName(id)[0];
        if (!target) return;

        event.preventDefault();
        if (window.location.hash !== url.hash) {
            window.history.pushState(null, '', url.hash);
        }

        lenis.scrollTo(target, {
            offset: -(parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0),
            immediate: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
            onComplete: () => {
                const tabindex = target.getAttribute('tabindex');
                target.setAttribute('tabindex', '-1');
                target.focus({ preventScroll: true });
                if (tabindex === null) {
                    target.removeAttribute('tabindex');
                } else {
                    target.setAttribute('tabindex', tabindex);
                }
            },
        });
    });
}
